export default __webpack_public_path__ + "static/media/maestro-ai-tag.0265ea4c.svg";